import { AxiosResponse } from 'axios';
import axios from '../api/axios';
import { EquipmentQueryResponse } from './_models';

const GET_LIST_URL = '/api/equipment/list';

export const getEquipment = (): Promise<EquipmentQueryResponse> => {
  return axios
    .get(GET_LIST_URL)
    .then((d: AxiosResponse<EquipmentQueryResponse>) => d.data)
    .catch(() => [] as never);
};
